module.exports = __webpack_public_path__ + "static/media/us_flag_small.404198b9.svg";